export default __webpack_public_path__ + "static/media/ovo_s.a6af9f64.jpg";